import * as React from "react";
import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";

import { PartialOhCaseDetailModel } from "../../crud/ohCase";
import { EmployeeRecordDetailModel } from "../../crud/employeeRecord";

interface Props {
    index?: number;
    readonly: boolean;
    ohCase: PartialOhCaseDetailModel;
    employeeRecord: EmployeeRecordDetailModel;
    questionnaireKey: string;
}

export class ConfidentialitySectionOld extends React.Component<Props> {
    public render() {
        const employeeAddressAndPostcode =
            `${this.props.employeeRecord ? `(${`${this.props.employeeRecord.addressLine1 || ""}, ${this.props.employeeRecord.postCode || ""}`})` : "" }`;

        return (
            <AccordionQuestionnaireSection
                id="Confidentiality"
                title="Confidentiality"
                index={this.props.index}
            >
                <p>For confidentiality reasons before we proceed I need to just ask you a few security questions?</p>
                <CheckboxQuestion
                    readonly={this.props.readonly}
                    questionConfig={({
                        id: "ConfirmDOB",
                        // eslint-disable-next-line max-len
                        questionText: `Please confirm your DOB? (${this.props.ohCase && this.props.ohCase.dateOfBirth && this.props.ohCase.dateOfBirth.format("L")})`
                    })}
                    value="Confirmed"
                />
                <CheckboxQuestion
                    readonly={this.props.readonly}
                    questionConfig={({
                        id: "ConfirmAddress",
                        // eslint-disable-next-line max-len
                        questionText: `Please could you also confirm the first line of your address and postcode? ${employeeAddressAndPostcode}`
                    })}
                    value="Confirmed"
                />
                <CheckboxQuestion
                    readonly={this.props.readonly}
                    questionConfig={({
                        id: "ConfirmOtherIdentifier",
                        // eslint-disable-next-line max-len
                        questionText: "If you are unable to match the DOB with address/postcode, use another identifier (e.g. case ref no. name of referring manager / place of work)"
                    })}
                    value="Confirmed"
                />
            </AccordionQuestionnaireSection>
        );
    }
}
